import { addDays } from 'date-fns';

import { queries } from 'RestAPIs/rapini';
import { toOptionalDateString } from 'utils/date';

/**
 * What applies to the organizational unit on the chosen date, inheritance included: the overview
 * shows that one day, and resolving the inheritance costs per day asked for. Not asked without a date.
 */
export const useGetEffectiveOpeningHours = (
  planUnitId: number,
  date: Date | null
) =>
  queries.useGetEffectiveOpeningHours(
    [planUnitId],
    toOptionalDateString(date),
    toOptionalDateString(date ? addDays(date, 1) : null),
    { enabled: !!date }
  );
